module.exports = __webpack_public_path__ + "static/media/upload_documents_pending.67ebd346.svg";